import React from 'react';
import styled from 'styled-components';
import { Iconify } from '../../../Xmerald-UI';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  min-height: 38px;
  margin: 0.5em 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
`;

export const VerifiedAccount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  min-height: 38px;
  color: #78bc28;
  font-weight: 600;
`;

export const CallToAction = ({ children, action, isLoading, isDisabled, className }) => {
  return (
    <Button
      type="button"
      disabled={Boolean(isDisabled)}
      className={`callToAction flex-row btn-pick btn-success ${className || ''}`}
      onClick={isDisabled ? undefined : action}
    >
      {children}
      {isLoading && <Iconify icon="ph:spinner-gap-fill" />}
    </Button>
  );
};
